var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeineBeitrgeAnzeigenOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.07 80.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6b00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tags",
    className: "cls-1",
    d: "M77.89,35.33L44.74,2.18C43.33,.78,41.42,0,39.43,0H7.5C3.36,0,0,3.36,0,7.5h0v31.92c0,1.99,.78,3.9,2.18,5.31l33.12,33.12c2.93,2.93,7.68,2.93,10.61,0,0,0,0,0,0,0l31.97-31.9c2.93-2.93,2.93-7.68,0-10.62ZM17.51,25.02c-4.14,0-7.5-3.36-7.5-7.51,0-4.14,3.36-7.5,7.51-7.5,4.14,0,7.5,3.36,7.5,7.5,0,4.14-3.36,7.51-7.5,7.51,0,0,0,0,0,0Zm80.39,20.93l-31.94,31.94c-2.93,2.93-7.68,2.93-10.61,0,0,0,0,0,0,0l-.05-.05,27.22-27.24c5.5-5.5,5.5-14.41,0-19.9,0,0,0,0,0,0L51.83,0h7.62c1.99,0,3.9,.78,5.31,2.18l33.12,33.12c2.93,2.93,2.93,7.68,0,10.61,0,0,0,0,0,0l.03,.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeineBeitrgeAnzeigenOrange);
export default __webpack_public_path__ + "static/media/Meine Beiträge Anzeigen_orange.122b3273294f485a5c0c5edab586d946.svg";
export { ForwardRef as ReactComponent };